// import Footer from './Footer';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const DefaultLayout = () => {
    return (
        <main className="md:grid md:grid-cols-[auto_1fr] min-h-screen font-cairo">
            <Sidebar />
            <div className="w-full flex flex-col min-h-screen relative">
                <Header />
                <div className="flex-grow m-auto px-5 lg:px-6 custom:px-0 w-full custom:w-[1104px]">
                    <Outlet />
                </div>
                {/* <Footer /> */}
            </div>
        </main>
    );
};

export default DefaultLayout;
